import colors from "assets/theme/base/colors";

function collapseItem(theme, ownerState) {
  const { palette, transitions, breakpoints, boxShadows, borders, functions } = theme;
  const { active, transparentSidenav } = ownerState;

  const { xxl } = boxShadows;
  const { pxToRem } = functions;

  return {
  
background: active ? "#599c16" : "transparent", // final selected

color: active ? "#FFFFFF" : colors.black.focus, // Deep green text when inactive

    display: "flex",
    alignItems: "center",
    width: "100%",
    padding: `${pxToRem(10.8)} ${pxToRem(12.8)} ${pxToRem(10.8)} ${pxToRem(16)}`,
    margin: "4px 12px",
    borderRadius: "8px",
    cursor: "pointer",
    userSelect: "none",
    whiteSpace: "nowrap",
    boxShadow: active && transparentSidenav ? xxl : "none",
    [breakpoints.up("xl")]: {
      boxShadow: () => {
        if (active) {
          return transparentSidenav ? xxl : "none";
        }

        return "none";
      },
      transition: transitions.create("box-shadow", {
        easing: transitions.easing.easeInOut,
        duration: transitions.duration.shorter,
      }),
    },
  };
}

function collapseIconBox(theme, ownerState) {
  const {  transitions, breakpoints, boxShadows, borders, functions } = theme;
  const { active } = ownerState;


  const { md } = boxShadows;
  const { borderRadius } = borders;
  const { pxToRem } = functions;

  return {

    minWidth: pxToRem(20),
    minHeight: pxToRem(20),
    borderRadius: borderRadius.md,
    display: "grid",
    placeItems: "center",
    boxShadow: "none",
    background:"transparent !important",
    transition: transitions.create("margin", {
      easing: transitions.easing.easeInOut,
      duration: transitions.duration.standard,
    }),

    [breakpoints.up("xl")]: {
      
    },

    "& svg, svg g": {

fill: active ? "#FFFFFF" : colors.black.focus,

    },
  };
}

const collapseIcon = ({ palette: { white, gradients } }, { active }) => ({

color: active ? "#FFFFFF" : colors.black.focus,
});

function collapseText(theme, ownerState) {
  const { typography, transitions, breakpoints, functions } = theme;
  const { miniSidenav, transparentSidenav, active } = ownerState;

  const { size, fontWeightMedium, fontWeightRegular } = typography;
  const { pxToRem } = functions;

  return {
    marginLeft: pxToRem(8),

    [breakpoints.up("xl")]: {
      opacity: miniSidenav || (miniSidenav && transparentSidenav) ? 0 : 1,
      maxWidth: miniSidenav || (miniSidenav && transparentSidenav) ? 0 : "100%",
      marginLeft: miniSidenav || (miniSidenav && transparentSidenav) ? 0 : pxToRem(8),
      transition: transitions.create(["opacity", "margin"], {
        easing: transitions.easing.easeInOut,
        duration: transitions.duration.standard,
      }),
    },

    "& span": {
      fontWeight: active ? fontWeightMedium : fontWeightRegular,
      fontSize: size.sm,
      lineHeight: 0,
      color: active ? "#FFFFFF" : colors.black.focus,
    },
  };
}

export { collapseItem, collapseIconBox, collapseIcon, collapseText };
